import { PlanFlow, PriceFrequency } from '@energy-retailer/constants';
import { z } from 'zod';

export const campaignSearchSchema = z.object({
  address: z.object({
    name: z.string(),
    id: z.string(),
  }),
  priceFrequency: z.nativeEnum(PriceFrequency),
  planFlow: z.nativeEnum(PlanFlow),
  hasGasPlans: z.boolean().default(true),
  electricityDistributor: z.string().optional(),
  gasDistributor: z.string().optional(),
});

export type CampaignSearchSchemaType = z.infer<typeof campaignSearchSchema>;
